// Pentest accounts skip the captcha; the backend exempts the same list.
export const isPentestEmail = (email: string): boolean =>
  (process.env.VUE_APP_PENTEST_EMAILS?.split(',') || []).includes(email);
